import { supabase } from "@/lib/supabase"
import { Person } from "@/types/person"
import { getFunctionsBaseUrl } from "@/utils/getFunctionsBaseUrl"

export interface FetchPeopleBody {
  statusFilter?: string
  searchQuery?: string
  functionAreaFilter?: string
  locationFilter?: string
  employerFilter?: string
  subTeamFilter?: string
  sheriffTypeFilter?: string
  personIdFilter?: string
  emailFilter?: string
  postcodeFilter?: string
  stickyLocationFilter?: string
  driverManagerTeamFilter?: string
  contractStartDateFilter?: string
  contractEndDateFilter?: string
  hpdPoolFilter?: string
  payBasisFilter?: string
  payRateFilter?: string
  contractTypeFilter?: string
  hasMultipleLocationsFilter?: "Yes" | "No" | ""
  filterTypes?: Record<string, string>
  limit?: number
  offset?: number
}

export interface FetchPeopleResponse {
  people: Person[]
  hasMore: boolean
  offset?: number
}

export async function fetchPeople(body: FetchPeopleBody): Promise<FetchPeopleResponse> {
  const { data: sessionData } = await supabase.auth.getSession()
  const token = sessionData?.session?.access_token

  if (!token) {
    throw new Error("No authentication token available")
  }

  const functionUrl = `${getFunctionsBaseUrl()}/fetch-people-supabase`

  const response = await fetch(functionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || `Failed to fetch people: ${response.statusText}`)
  }

  const data = await response.json()
  return data
}

export const peopleService = {
  fetchPeople,
}
